import { useEffect } from 'react';
import { SettingsRoutes } from './settings-routes';
import { NavigateArgs, useSettingsNavigate } from './use-settings-navigate';

export function SettingsNavigate<T extends SettingsRoutes>(props: NavigateArgs<T>) {
  const { navigate: settingsNavigate } = useSettingsNavigate();
  useEffect(() => {
    settingsNavigate(props);
  }, []);
  return null;
}
